module.exports = __webpack_public_path__ + "images/wallpaper_iphone_remote_control.jpeg?de6946bbde593e3c432ea732c7f506eb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wallpaper_iphone_remote_control.jpeg
// module id = 93
// module chunks = 0